import { render } from "./radioPage.vue?vue&type=template&id=7aadee95"
import script from "./radioPage.vue?vue&type=script&lang=js"
export * from "./radioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__